export default __webpack_public_path__ + "static/media/Lexus-logo-3D-horizontal-platinum-tagline.28787414.png";